import React, { useState } from 'react'
import PropTypes from 'prop-types'
import GenericConfirmModal from './GenericConfirmModal'

const RecallSubmissionBulk = ({ visible, onClose, onBulkRecall }) => {
  const [isClicked, setIsClicked] = useState(false)
  return (
    visible && (
      <GenericConfirmModal
        content={'Encounter will be recalled'}
        onClose={onClose}
        onConfirm={() => {
          if (!isClicked) {
            setIsClicked(true)
            onBulkRecall()
          }
        }}
      />
    )
  )
}

RecallSubmissionBulk.propTypes = {
  visible: PropTypes.bool,
  onClose: PropTypes.func,
  onBulkRecall: PropTypes.func,
}

export default RecallSubmissionBulk
